import { Shield, Heart, TrendingUp, Users, Clock, Sparkles } from "lucide-react";

const benefits = [
  {
    icon: Shield,
    title: "Pilar 1 – Liberdade x Abismo",
    description: "Você vai entender o que te leva ao fundo do poço e o que te faz subir de volta. Esse pilar mostra como suas decisões moldam a vida que você vive — e como retomar o controle agora.",
  },
  {
    icon: Heart,
    title: "Pilar 2 – Reconhecimento & Conscientização",
    description: "Reconhecer o vício é fácil, porém entendê-lo de verdade é o que muda tudo. Aqui você vai descobrir verdades que o vício esconde de você — e enxergar o tamanho real da sua prisão.",
  },
  {
    icon: TrendingUp,
    title: "Pilar 3 – Esperança & Motivação",
    description: "O entusiasmo inicial passa, e jornadas como essa não são fáceis — por isso as pessoas desistem de coisas difíceis. Você aprenderá a manter o foco e a motivação mesmo nos dias difíceis, com uma mente constantemente firme.",
  },
  {
    icon: Users,
    title: "Pilar 4 – Estratégias de Autocontrole",
    description: "Nesse pilar o vício perde o controle sobre você. Aprenderá a dominar totalmente seus impulsos e descobrirá técnicas práticas para manter o controle e agir com consciência.",
  },
  {
    icon: Clock,
    title: "Pilar 5 - Reconstrução de Identidade",
    description: "O vício te fez esquecer quem você era. Você nem se reconhece mais, porém vamos te ajudar a redescobrir sua essência, seus valores e princípios e ensiná-lo como se reencontrar e ter orgulho de si mesmo.",
  },
  {
    icon: Sparkles,
    title: "Pilar 6 – Reparação & Responsabilidade",
    description: "É hora de consertar o que o vício destruiu, o vício deixou rastros pela vida financeira, relacionamentos, saúde e etc. Está na hora de assumir a responsabilidade e aprender como restaurar tudo que ficou quebrado, desde relacionamentos até a conta bancária.",
  },
  {
    icon: Sparkles,
    title: "Pilar 7 – Construção de Nova Vida",
    description: "É normal se sentir “vazio” ao abandonar um vício. Vamos preencher esse vazio com novos hábitos, propósitos e prazeres genuínos pela vida. Reaprender a viver e alcançar até mesmo a sua melhor versão (uma versão que você nem imaginou existir) mas sabemos que é capaz.",
  },
  {
    icon: Sparkles,
    title: "Pilar 8 – Prevenção de Recaídas & Manutenção",
    description: "A liberdade só é verdadeira quando é permanente, definitiva! Nesse pilar, você aprenderá como proteger sua mente e se manter firme, mesmo diante das tentações.",
  },
];

export const Benefits = () => {
  return (
    <section className="py-20 relative">
      <div className="container px-4">
        <div className="text-center mb-16 animate-slide-up">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            O Que Você Vai{" "}
            <span className="bg-gradient-accent bg-clip-text text-transparent">
              Conquistar
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            O Método Libertação Das Apostas vai além de parar de apostar. É a reconquista da sua liberdade, da sua familia e da sua paz. Uma transformação de corpo e alma.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group relative animate-scale-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Glass card */}
              <div className="relative h-full backdrop-blur-xl bg-card/40 rounded-2xl p-6 border border-primary/20 hover:border-primary/40 transition-all duration-500 hover:shadow-[0_8px_32px_rgba(100,192,242,0.2)] hover:-translate-y-2">
                {/* Icon */}
                <div
                  className="w-14 h-14 rounded-xl mb-4 group-hover:scale-110 shadow-lg transition-transform duration-300 bg-cover bg-center"
                  style={{
                    backgroundImage: `url(${new URL(`../assets/adesivos/pilar${index + 1}.png`, import.meta.url).href})`,
                  }}
                />


                {/* Content */}
                <h3 className="text-xl font-bold mb-2">{benefit.title}</h3>
                <p className="text-muted-foreground">{benefit.description}</p>

                {/* Hover glow */}
                <div className="absolute inset-0 bg-gradient-radial from-primary/10 via-transparent to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
